<template>
    <b-sidebar
        v-if="isSidebarOpen"
        v-model="isSidebarOpen"
        id="sidebar-right"
        right
        backdrop
        shadow
        width="109em"
        backdrop-variant="dark"
        ref="editItem"
        no-close-on-backdrop
        no-close-on-route-change
        @change="closeSidePanelCallback()"
    >
        <template #title>
            <div>
                <strong id="sidebar-right___title__">{{ label }}</strong>
                <b-button @click="exportTable('financeTable', 'finance')" size="sm" class="mb-1 mr-2" v-if="items.length > 0">
                    Экспорт
                    <b-icon icon="cloud-download" aria-hidden="true" v-if="!isExportData"></b-icon>
                    <i class="fas fa-spinner fa-spin" v-else></i>
                </b-button>
            </div>
        </template>
        <div class="d-block">
            <b-table
                id="financeTable"
                striped hover
                :items="items"
                :fields="fields"
                :sticky-header="computedWindowHeight"
                :busy="isTableBusy"
                :sort-by="'order_id'"
                :sort-desc="false"
            >
                <template #cell()="data">
                    <template v-if="data.field.loading">
                        <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template v-else>
                        {{ data.value || "—" }}
                    </template>
                </template>
                <template #cell(order_id)="data">
                    <span class="sidebar-link" @click="openOrderSidebar(data.value, '', {tab: 'order-finance'})">{{ data.value }}</span>
                </template>
                <template #cell(company_name)="data">
                    <span class="sidebar-link" @click="openCompanySidebar(data.item.company_id)">{{ data.value }}</span>
                    <div v-if="data.item.company_perc_of_mp < 100" class="text-muted"><small>В расчёты берётся {{ data.item.company_perc_of_mp }}% от МП</small></div>
                </template>
                <template #cell(final_sum)="data">
                    {{ formatNumbers(data.value) }}
                </template>
                <template #cell(close_actual_date)="data">
                    {{ data.value | formattedDate }}
                </template>
                <template #cell(finance_ids)="data">
                    <span 
                        v-for="(item, index) in data.item.finance_ids" 
                        :key="item.id" 
                        class="sidebar-link" 
                        @click="openFinanceSidebar(item.id)"
                    >
                        {{ item.invoice_number }}<span v-if="item.finance_virtuals_id" :title="`Виртуальный счет #${item.finance_virtuals_id}`" style="color:#000;"><sup>&#x1F6C8;</sup></span>
                        <template v-if="index != data.item.finance_ids.length - 1">, </template>
                    </span>
                </template>
                <template v-slot:table-busy>
                    <div class="text-center text-success my-5">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
            </b-table>
        </div>
    </b-sidebar>
</template>
<script>
    import { API_GET_MOTIVATION_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS } from "../../constants";
    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        excelExportHelpers,
        toCurrency
    } from '../../mixins'
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';
    import { openFinanceSidebar } from '@/mixins/openFinanceSidebar';

    export default {
        props: {
            openFinanceList: { type: Boolean, required: true },              // Need to open financeList
            financeList: { type: Array, required: true },                    // Open List
            userIds: { type: Array, required: false },                       // User ids for calc operations
            cbr: { type: Object, required: false },                          // Send valutes currencies for calc operations
            periodStart: {type: String, required: false},                    // Period start for check company portfolio status
            periodEnd: {type: String, required: false},                      // Period start for check company portfolio status
            label: {                                                         // List label for sidebar
                        type: String,
                        default: 'Список расчетов МП сотрудника по поставка',
                        required: false
                   },
            to_manager_from_order: {type: Boolean, default: null},
            needItogs: { type: Boolean, required: false, default: true },   // Need itogs button
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            excelExportHelpers,
            openFinanceSidebar,
            openCompanySidebar,
            openOrderSidebar
        ],
        data() {
            return {
                isTableBusy: false,
                computedWindowHeight: '',
                fields: [
                    {
                        'key': 'order_id',
                        'label': 'Номер поставки',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'company_name',
                        'label': 'Компания',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true
                    },
                    {
                        'key': 'final_sum',
                        'label': 'Сумма в зачет МП, рубли',
                        'stickyColumn': true,
                        'sortable': true,
                        'sortDirection': 'desc',
                        'visible': true,
                        'tdAttr': {
                            'data-t': 'n',
                        }
                    }, 
                    {
                        'key': 'finance_ids',
                        'label': 'Счета в расчетах',
                        'stickyColumn': false,
                        'sortable': false,
                        'sortDirection': 'desc',
                        'visible': true
                    },                                       
                    // {
                    //     'key': 'close_actual_date',
                    //     'label': 'Дата закрытия',
                    //     'sortable': false,
                    //     'sortDirection': 'desc',
                    //     'visible': true
                    // },
                    // {
                    //     'key': 'actions',
                    //     'label': 'Действия',
                    //     'stickyColumn': true,
                    //     'visible': true
                    // },
                ],
                items: [],
                itogsActivate: false,
                itogs: []
            }
        },
        watch: {
            financeList: {
                handler(ids) {
                    this.getDataHandler(ids)
                },
                immediate: true
            }
        },
        created() {
            window.addEventListener("resize", this.handlerHeightWindow);
        },
        destroyed() {
            window.removeEventListener("resize", this.handlerHeightWindow);
        },
        mounted() {
            this.handlerHeightWindow()
        },
        methods: {
            handlerHeightWindow() {
                let deleteHeight = 115
                this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
            },
            getDataHandler: async function(ids) {
                this.isTableBusy = true
                this.isSidebarOpen = true

                let finalIdsList = []

                if (ids[0].finance_id) {
                    finalIdsList = ids.map((id) => {
                        return id.finance_id
                    })
                } else {
                    finalIdsList = ids
                }

                let apiUrl = API_GET_MOTIVATION_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS

                let additionalParams = {};

                // if (this.needGroup) {
                //     apiUrl = API_GET_MOTIVATION_FINANCE_BY_IDS_GROUPED_BY_CLOSED_ORDERS
                //     this.fields = initialFieldsForGroupesByOrders()
                // }

                await api.call('post', apiUrl, {...{"finance_ids": finalIdsList, "user_ids": this.userIds, "period_start": this.periodStart, "period_end": this.periodEnd}, ...additionalParams})
                    .then((response) => {
                        this.isTableBusy = false
                        this.items = response.data.items
                    })
            },
            closeSidePanelCallback() {
                this.closeFinanceList()
                this.isSidebarOpen = false
            },
            closeFinanceList() {
                this.$emit("closeFinanceList")
            },
        }
    }
</script>
